<template>
  <div class="login-form">
    <div class="title">
      {{ title }}
    </div>
    <div class="tips" v-if="tips">{{tips}}</div>
    <van-form @submit="onSubmit">
      <van-field type="number" maxlength="11" v-model="mobile" name="手机号" label="手机号" placeholder="手机号"
        :rules="[{ required: true, message: '请填写手机号', trigger: 'onChange' }]" />
      <van-field type="number" v-model="code" maxlength="8" name="验证码" label="验证码" placeholder="验证码"
        :rules="[{ required: true, message: '请填写验证码', trigger: 'onChange' }]">
      </van-field>
      <van-field name="" label="" input-align="right">
        <template #input>
          <van-button :disabled="timeout > 0" size="small" type="primary" @click.prevent="sendSms">
            {{ timeout > 0 ? '请稍等 ' + timeout + '秒' : '获取验证码' }}
          </van-button>
        </template>
      </van-field>
      
      <div style="margin: 16px;">
        <van-button block type="info" size="small" native-type="submit">确认绑定</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { verifyCode, mobileBind } from '@/api';
import { Toast } from 'vant';
import createNEGuardian from  '@/utils/YiDunProtector-Web-2.1.1.js';

const neg = createNEGuardian({ productId: window.__config__.ypid, timeout: 6000 })

export default {
  name: 'LoginForm',
  props: {
    state: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tips: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      mobile: '',
      code: '',
      timeout: false,
      timer: undefined,
      
    }
  },
  mounted() {
    if (!this.state) {
      this.$emit('error')
    }

  },
  methods: {
    async onSubmit() {
      if (!this.mobile)
        return Toast('请先填写手机号')
      if (!this.code)
        return Toast('请先填写验证码')
      
      await mobileBind({
        mobile: this.mobile,
        state: this.state,
        code: this.code
      })
      await this.$store.dispatch('syncUser')
      this.$emit('success')  
    },
    async sendSms() {
      if (!this.mobile)
        return Toast('请先填写手机号')

      let token;
      if (window.__config__.ypopen) {
        token = await (new Promise(resolve => {
          neg.getToken().then(result => {
            if (result.code == 200 || result.code == 201) {
              resolve(result.token)
            } else {
              resolve(undefined)
            }
          })
        }))
      }

      await verifyCode({
        mobile: this.mobile,
        state: this.state,
        token: token
      })
      this.timeout = 60;
      this.timer = setInterval(() => {
        if (this.timeout > 0) {
          this.timeout -=1
        } else {
          clearInterval(this.timer)
          this.timeout = false;
        }
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
.login-form {
  width: 380px;
  max-width: 90vw;
  min-height: 240px;
  padding-bottom: 10px;
  .title {
    font-size: 20px;
    font-weight: 400;
    padding: 18px 12px 18px 12px;
    text-align: center;
    border-bottom: 1px solid #efefef;
    margin-bottom: 12px;
  }
  .tips {
    font-size: 14px;
    color: #b06563;
    text-align: center;
    padding: 8px 8px 12px 8px;
  }
}
</style>
